export default __webpack_public_path__ + "assets/obituary.56b9bd05.svg";